export default __webpack_public_path__ + "static/media/menu_top_duet.e53ad491.svg";